import { render, staticRenderFns } from "./NovaProgramacaoUnidade.vue?vue&type=template&id=8aa881ee"
import script from "./NovaProgramacaoUnidade.vue?vue&type=script&lang=js"
export * from "./NovaProgramacaoUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports